import * as React from 'react';
import Container from '@mui/material/Container';
import GlobalStyles from "@mui/material/GlobalStyles/GlobalStyles";
import Button from "@mui/material/Button/Button";
import Typography from "@mui/material/Typography/Typography";
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import firebase from "../../firebase/firebase";
import Stack from "@mui/material/Stack/Stack";
import MenuItem from "@mui/material/MenuItem";

import TextField from "@mui/material/TextField/TextField";

import * as yup from 'yup';
import { useFormik } from 'formik';
import Dialog from "@mui/material/Dialog/Dialog";
import DialogTitle from "@mui/material/DialogTitle/DialogTitle";
import IconButton from "@mui/material/IconButton/IconButton";
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from "@mui/material/DialogContent/DialogContent";
import DialogContentText from "@mui/material/DialogContentText/DialogContentText";
import InputAdornment from "@mui/material/InputAdornment";
import AttachFileIcon from "@mui/icons-material/AttachFile"
import {useContext} from "react";
import {AuthUserContext} from "../../providers/AuthProvider";
import {styled} from "@mui/material/styles";
import PostNotification from "../../helpers/post-notification";
import ScrollToTop from '../../utils/scrollTop';
import { CircularProgress } from '@mui/material';
import PostActivity from "../../helpers/post-activity";
const Input = styled('input')({
  display: 'none',
})
export default function PaymentBankDetails(){
  const { profile} = useContext(AuthUserContext);

  const [data, setData] = React.useState({contract: {}, project: {}, ndaURL:''});
  const [uploading, setUploading] = React.useState(false)
  const [open, setOpen] = React.useState(false);
  const [attachment, setAttachment] = React.useState();
  const location = useLocation();
  const {
    haveYouMadeThePayment,
    amount,
    projectId
  } = location.state
  let { contractId } = useParams();

  const navigator = useNavigate()

  const formik = useFormik({
    initialValues: {
      country:'',
      transactionNumber:'',
      bankName:'',
      accountTitle:'',
      recipientsName:'',
      recipientsAddress:'',
      accountNumber:'',
      accountType:'',
      BICSwiftCode: '',
      attachment:'',
      // IBAN: '',
      // beneficiaryFullname:'',
      // beneficiaryAddress:'',
      // beneficiaryBIC:'',
      // BeneficiaryCountry:'',

    },
    validationSchema: yup.object({
      country: yup.string('country').required('Country required'),
      transactionNumber: yup.string('Transaction Number').required('Transaction Number is required').min(12,'Transaction Number must be of 12 characters in length').max(18,'Transaction Number must be of 18 characters in length'),
      beneficiaryFullname: yup.string('Beneficiary Full name').min(3,'Beneficiary Full Name must be of 3 characters in length').max(35,'Beneficiary Full Name must be of 35 characters in length'),
      beneficiaryAddress: yup.string('Beneficiary Address').min(3,'Beneficiary Address must be of 3 characters in length').max(35,'Beneficiary Address must be of 35 characters in length'),
      recipientsAddress: yup.string('Recipient Address').required('Recipient Address is required').min(3,'Recipient Address must be of 3 characters in length'),
      recipientsName: yup.string('Recipients name').required("Recipient's name is required").min(3,'Recipient must be of 3 characters in length'),
      beneficiaryBIC: yup.string('Beneficiary BIC').min(4,'Beneficiary BIC must be of 4 characters in length').max(11,'Beneficiary BIC must be of 11 characters in length'),
      BeneficiaryCountry: yup.string('Beneficiary Country'),
      accountType: yup.string('Account Type').required('Account Type is required'),
      BICSwiftCode: yup.string('').required("BIC/Swift Code is required"),
      bankName: yup.string('bankName').required('Bank Name is required').min(3,'Bank Name must be of 3 characters in length').max(35,'Bank Name must be of 35 characters in length'),
      IBAN: yup.string('IBAN').min(16,'IBAN must be of 16 characters in length').max(19,'IBAN must be of 19 characters in length'),
      accountTitle: yup.string('accountTitle').required('Account Title is required').min(3,'accountTitle must be of 3 characters in length').max(35,'Account Title must be of 35 characters in length'),
      accountNumber: yup.string('accountNumber').required('Account Number is required').min(16,'accountNumber must be of 16 characters in length').max(19,'Account Number must be of 19 characters in length'),
      attachment: yup.string('attachment').required("Please attach payment slip"),
    }),
    
    onSubmit: async (values) => {
      let contractURL = '';
      if (data?.contract && data?.contract?.signContract && data?.contract?.signContract?.investor) {
        contractURL = data?.contract?.signContract?.investor
      }
      const receiptRef = firebase.firestore().collection('receipts');
      await receiptRef.add({
        contractId,
        projectId,
        amount,
        createdBy: profile.uid,
        createdByName: profile?.name,
        ...values,
        projectTitle: data?.project.title,
        contractURL,
        ndaURL: data?.ndaURL,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      })

      const project = {id: projectId, ...data.project}
      const stateObject = {state: {project, tab: 2}};
      const postId = await PostNotification({
        title: 'A new invoice was received',
        text: 'A new received invoice is pending approval. Click here to review it.\n',
        uid: null,
        createdBy:'self',
        showing:['super'],
        link: '/admin/project-management',
        state: JSON.stringify(stateObject)
      });
      PostActivity({
        text: `You have made an investment of ${amount} into project "${project?.title}"`,
        uid: profile.uid,
        createdBy:profile?.uid
      }).then()
      console.log(`Notify Admin ${postId}`)

      setOpen(true)
    }
  })
  const loadData = async () => {
    try {
      const projectsRef = firebase.firestore().collection('projects').doc(projectId);
      let nda = firebase.firestore().collection('NDA').where('uid', '==', profile?.uid);
      nda = nda.where('projectId', '==', projectId);
      const ndaSnapshot = await nda.get()
      const ndaURL = ndaSnapshot.size > 0 ? ndaSnapshot.docs[0].data().signNdaPath : ''
      const project = await projectsRef.get()
      const contractsRef = firebase.firestore().collection('contracts').doc(contractId);
      const contract = await contractsRef.get()
      setData({project: project.data(), contract: contract.data(), ndaURL})
    } catch (e) {
      console.log(`ERROR: ${e.toString()}`)
    }
  }
  const uploadFile = (e) => {
    setUploading(true)
    const storageRef = firebase.storage().ref();

    const file = e.target.files[0]
    const path = `receipts/${data.project?.title.replace(' ', '-')}/${profile?.name.replace(' ', '-')+'-'+ profile?.uid}/${file.name.replace(' ', '-')}`
    const uploadTask = storageRef.child(path).put(file);

    uploadTask.on('state_changed',
      (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log('Upload is ' + progress + '% done');
      /*  const image = {...profileImage, progress}
        setProfileImage(image)*/
        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED: // or 'paused'
            console.log('Upload is paused');
            break;
          case firebase.storage.TaskState.RUNNING: // or 'running'
            console.log('Upload is running');
            break;
        }
      },
      (error) => {
        setUploading(false)
      },
      () => {
        formik.setFieldValue('attachment', path)
        setUploading(false)
      }
    );

  }
  React.useEffect(() => {
    loadData()
  }, [])

  return(

      <React.Fragment>
        <ScrollToTop/>
        <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
        {/* Hero unit */}
        {/*<TopBar showBar={true}/>*/}
        <Container maxWidth="fullWidth" sx={{backgroundColor: '#E3E8F0', paddingY: 8,  mb: 8, textAlign:'left'}}>
          <Container maxWidth="lg">
            <Typography variant={'h4'} sx={{pl: 2}} color={'primary'}>
              PAYMENT
            </Typography>
          </Container>
        </Container>
        <Container maxWidth="md" sx={{textAlign:'left' }}>
          <Stack component={'form'} direction={'column'} spacing={5} onSubmit={formik.handleSubmit}>
            <Typography variant={'h5'} color={'primary'} >
              PLEASE ADD YOUR BANK DETAILS
            </Typography>

            <TextField variant={'outlined'} fullWidth  label={'Select your country'} name={'country'}
                       value={formik.values.country}
                       onChange={formik.handleChange}
                       error={formik.touched.country && Boolean(formik.errors.country)}
                       helperText={formik.touched.country && formik.errors.country}
                       select>
              <MenuItem value={'United State'}>
                United States
              </MenuItem>
            </TextField>
            <TextField variant={'outlined'} fullWidth  label={'Transaction number'} name={'transactionNumber'}
                       value={formik.values.transactionNumber}
                       onChange={formik.handleChange}
                       error={formik.touched.transactionNumber && Boolean(formik.errors.transactionNumber)}
                       helperText={formik.touched.transactionNumber && formik.errors.transactionNumber}
                       type={'number'}
            />
            <TextField variant={'outlined'} fullWidth   label={'Bank name'} name={'bankName'}
                       value={formik.values.bankName}
                       onChange={formik.handleChange}
                       error={formik.touched.bankName && Boolean(formik.errors.bankName)}
                       helperText={formik.touched.bankName && formik.errors.bankName}

            />
            <TextField variant={'outlined'} fullWidth   label={'Account title'} name={'accountTitle'}

                       value={formik.values.accountTitle}
                       onChange={formik.handleChange}
                       error={formik.touched.accountTitle && Boolean(formik.errors.accountTitle)}
                       helperText={formik.touched.accountTitle && formik.errors.accountTitle}

            />
            <TextField variant={'outlined'} fullWidth   label={"Sender's full name"} name={'recipientsName'}

                       value={formik.values.recipientsName}
                       onChange={formik.handleChange}
                       error={formik.touched.recipientsName && Boolean(formik.errors.recipientsName)}
                       helperText={formik.touched.recipientsName && formik.errors.recipientsName}

            />
            <TextField variant={'outlined'} fullWidth   label={"Sender's address"} name={'recipientsAddress'}

                       value={formik.values.recipientsAddress}
                       onChange={formik.handleChange}
                       error={formik.touched.recipientsAddress && Boolean(formik.errors.recipientsAddress)}
                       helperText={formik.touched.recipientsAddress && formik.errors.recipientsAddress}
            />
            <TextField variant={'outlined'} fullWidth   label={'Account number'} name={'accountNumber'}

                       value={formik.values.accountNumber}
                       onChange={formik.handleChange}
                       error={formik.touched.accountNumber && Boolean(formik.errors.accountNumber)}
                       helperText={formik.touched.accountNumber && formik.errors.accountNumber}
            />
            <TextField variant={'outlined'} fullWidth   label={'Account Type'} name={'accountType'}

                       value={formik.values.accountType}
                       onChange={formik.handleChange}
                       error={formik.touched.accountType && Boolean(formik.errors.accountType)}
                       helperText={formik.touched.accountType && formik.errors.accountType}
            />
            <TextField variant={'outlined'} fullWidth   label={'BIC/SWIFT Code'} name={'BICSwiftCode'}

                       value={formik.values.BICSwiftCode}
                       onChange={formik.handleChange}
                       error={formik.touched.BICSwiftCode && Boolean(formik.errors.BICSwiftCode)}
                       helperText={formik.touched.BICSwiftCode && formik.errors.BICSwiftCode}
            />
            {/* <TextField variant={'outlined'} fullWidth   label={'Account Number'} name={'accountNumber'}

                       value={formik.values.accountNumber}
                       onChange={formik.handleChange}
                       error={formik.touched.accountNumber && Boolean(formik.errors.accountNumber)}
                       helperText={formik.touched.accountNumber && formik.errors.accountNumber}
                       type={'number'}
            /> */}
            <label htmlFor="attachment">
              <Input accept="**/*" id="attachment" multiple={false} type="file" onChange={uploadFile}/>
              <TextField  fullWidth label={'Please attach your payment slip/receipt'}
                       value={formik.values.attachment}
                       error={formik.touched.attachment && Boolean(formik.errors.attachment)}
                       helperText={formik.touched.attachment && formik.errors.attachment}
                       InputProps={{
                         endAdornment: (
                             <InputAdornment position="end">
                               <IconButton component={'span'}>
                                {uploading ? <CircularProgress size={25}/>
                                : <AttachFileIcon sx={{color:"#204488"}}/>
                                }
                               </IconButton>
                             </InputAdornment>
                         ),
                       }}
              /></label>

            <Stack direction={'row'} justifyContent="center"
                   alignItems="center" sx={{pb: 10}}>
              <Button variant={'contained'} size={'large'} sx={{px: 7}} type='submit' >
                Next
              </Button>
            </Stack>

          </Stack>

        </Container>
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth='sm'
        >
          <DialogTitle id="alert-dialog-title" >
            <Stack direction={'row'} spacing={2}>
              <Typography variant={'h6'} sx={{flex:1, textAlign:'center'}} color={'primary'}>Thank you!</Typography>
              <IconButton color={'primary'} onClick={() => {
                setOpen(false)
                navigator('/investor/dashboard')
              }}>
                <CloseIcon/>
              </IconButton>
            </Stack>


          </DialogTitle>
          <DialogContent sx={{py: 5}}>
            <DialogContentText id="alert-dialog-description" >
              <Typography variant={'body2'} sx={{textAlign:'center'}}>We will notify you when the payment is received.</Typography>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </React.Fragment>
  )
}
